"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  TickerContext: true,
  TickerController: true,
  useTicker: true
};
exports.useTicker = exports.TickerController = exports.TickerContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@fure/core");

var _Subscribe = require("./Subscribe");

Object.keys(_Subscribe).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Subscribe[key];
    }
  });
});

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var TickerContext = (0, _react.createContext)(_core.Ticker.shared);
exports.TickerContext = TickerContext;
TickerContext.displayName = 'Ticker';

var TickerController = function TickerController(_ref) {
  var _ref$ticker = _ref.ticker,
      ticker = _ref$ticker === void 0 ? _core.Ticker.shared : _ref$ticker,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$running = _ref.running,
      running = _ref$running === void 0 ? true : _ref$running,
      autoStart = _ref.autoStart;
  if (running !== ticker.running) running ? ticker.start() : ticker.pause();
  if (autoStart != null && autoStart != ticker.autoStart) ticker.autoStart = autoStart;
  (0, _react.useEffect)(function () {
    return function () {
      ticker.pause();
    };
  }, []);
  return _react.default.createElement(TickerContext.Provider, {
    value: ticker
  }, children);
};

exports.TickerController = TickerController;

var useTicker = function useTicker() {
  var ticker = (0, _react.useContext)(TickerContext);
  (0, _react.useDebugValue)(ticker, function (ticker) {
    return ticker.FPS.toFixed(2);
  });
  return ticker;
};

exports.useTicker = useTicker;